import newCoreLogo from '../assets/coreGamingLogo.webp'
import flutterStudiosLogo from '../assets/flutterStudios.webp'

import Container from 'react-bootstrap/Container';

import Navbar from 'react-bootstrap/Navbar';



const NavBar = () => {
  
  return (
    <>
    <Navbar /** sticky="top" */ bg="dark" expand="lg" className="justify-content-center" >
        <Container className="navBarContainer">
            <Navbar.Brand  href="#home" className="navbarLogos ">
                <img
                src={flutterStudiosLogo}
                width="150"
                height="auto"
                className="d-inline-block align-top navbarImages flutterStudiosLogo "
                alt="flutter studios Logo"
                />
          </Navbar.Brand>
            <Navbar.Brand  href="#home" className="navbarLogos">
                <img
                src={newCoreLogo}
                width="150"
                height="auto"
                className="d-inline-block align-top navbarImages coreGamingLogo"
                alt="CORE Gaming Logo"
                />
          </Navbar.Brand>
    

        </Container>
       

    </Navbar>
    <hr className= "redLine"/>
    </>


  )
}

export default NavBar